import { defaultOnSubmit } from '../../../utils/defaultOnSubmit';

export const onSubmit = async ({ formData, apolloClient, extraData }) => {
  const variables = { ...formData };
  return defaultOnSubmit({ formData: variables, apolloClient, extraData });
};
